import { observable, action } from 'mobx';
import agent from '../../api/agent';
import navigatorStore from '../navigatorStore'
class ArtworkStore {
    @observable paginationLimit = 25;
    @observable paginationOffset = 0;
    @observable paginationLimitCollection = 25;
    @observable paginationOffsetCollection = 0;
    @observable paginationLimitCollectionProfile = 25;
    @observable paginationOffsetCollectionProfile = 0;
    @observable query = {};
    @observable title = ""
    @action setQuery(input, title) {
        this.query = input
        this.title = title
    }
    @action getAllArtworks() {
        // console.log(this.paginationOffset)
        // let queryString = querystring.stringify({limit : this.paginationLimit ,offset : this.paginationOffset });
        return agent.Artworks.getArtworksByCategory(this.query, { limit: this.paginationLimit, offset: parseInt(this.paginationOffset) })
            .catch(action(err => {
                // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                navigatorStore.openErrorModal("Something went wrong. Please try again.");
            }))
    }
    @action createNewArtwork(body) {
        return agent.Artworks.createNewArtwork(body)

        // else this.addArtworkImage(body)
    }
    @action addArtworkImage(id, body) {
        return agent.Artworks.addArtworkImage(id, body)
    }
    @action updateArtwork(id, body) {
        return agent.Artworks.updateArtwork(id, body)
    }
    @action getArtworkDetailsPrivate(id) {
        return agent.Artworks.getArtworkDetailsPrivate(id)
    }
    @action getArtworkDetailsPublic(id) {
        return agent.Artworks.getArtworkDetailsPublic(id)
    }
    @action getArtworkDetailsPublicAuth(id, body, hideTheLoader) {
        return agent.Artworks.getArtworkDetailsPublicAuth(id, body, hideTheLoader)

    }
    @action getArtworkCollection(id, hide) {
        return agent.Artworks.getArtworkCollectionPublicAuth(id, hide, { limit: this.paginationLimitCollection, offset: parseInt(this.paginationOffsetCollection) })

    }
    @action getArtworkCollectionProfile(id, hide) {
        return agent.Artworks.getArtworkCollectionPublicAuth(id, hide, { limit: this.paginationLimitCollectionProfile, offset: parseInt(this.paginationOffsetCollectionProfile) })

    }

    @action reportArtwork(id, body) {
        return agent.Artworks.reportArtwork(id, body)
    }
    @action loadmore() {
        // console.log("came here")
        this.paginationOffset = this.paginationOffset + 25;
        this.paginationLimit = this.paginationLimit + 25;
        // console.log(this.paginationOffset)
        // this.getAllArtworks()
    }
    @action loadmoreCollection() {
        // console.log("came here")
        this.paginationOffsetCollection = this.paginationOffsetCollection + 25;
        // this.paginationLimitCollection = this.paginationLimitCollection + 25;
        // console.log(this.paginationOffset)
        // this.getAllArtworks()
    }
    @action resetCollection() {
        // console.log("came here")
        this.paginationLimitCollection = 25;
        this.paginationOffsetCollection = 0;
        // console.log(this.paginationOffset)
        // this.getAllArtworks()
    }
   
    @action resetCollectionMyProfile() {
        // console.log("came here")
        this.paginationLimitCollectionProfile = 25;
        this.paginationOffsetCollectionProfile = 0;
        // console.log(this.paginationOffset)
        // this.getAllArtworks()
    }
    @action loadmoreCollectionMyProfile() {
        // console.log("came here")
        this.paginationOffsetCollectionProfile = this.paginationOffsetCollectionProfile + 25;
        this.paginationLimitCollectionProfile = this.paginationLimitCollectionProfile + 25;
        // console.log(this.paginationOffset)
        // this.getAllArtworks()
    }


}
export default new ArtworkStore();


// WEBPACK FOOTER //
// ./src/stores/artworksStores/artworksStore.js